module.exports = __webpack_public_path__ + "fonts/Pretendard-Regular.subset.0e570172.woff2";